<template>
    <transition name="slide" mode="out-in">
        <div class="register-success-tbf">
            <div class="success-modal">
                <div class="content-modal">
                    <div class="content-icon success-register">
                        <img src="/build/images/birdsimple.png" />
                    </div>
                    <div class="title">Pregătim ceva și mai bun!</div>
                    <div class="container-content-modal">
                        <div class="container-message">
                            Pentru a avea o experiență și mai placută în TBF Digital e nevoie să facem câteva lucrări de mentenanță. Așadar, până joi, 16 septembrie, ora 08:00, TBF Digital nu va fi disponibil.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
	data(){
		return {
		}
	},
    mounted() {
        // window.location.href = 'https://obiective.tbf.ro/';
    },
	methods: {
        redirect() {

        }
	}
}
</script>